'use client'
import { __awaiter } from '../../_virtual/_tslib.js';
import { Eip6963ProviderSingleton, retryableFn } from '@dynamic-labs/utils';
import StarknetWalletConnector from '../starknetWalletConnector.js';
import { createMetaMaskProviderWrapper } from '../utils/starknetSnap.js';

class MetaMask extends StarknetWalletConnector {
    constructor(opts) {
        super('MetaMask Starknet', 'metamask_snap', opts);
        this.overrideKey = 'metamaskstarknet';
        this.canSetEventListeners = false;
        if (!window.starknet_metamask_snap) {
            const { providers } = Eip6963ProviderSingleton.get();
            const metamaskProvider = providers.find((p) => ['io.metamask', 'io.metamask.flask'].includes(p.info.rdns));
            if (metamaskProvider) {
                window.starknet_metamask_snap = createMetaMaskProviderWrapper(metamaskProvider.provider);
            }
        }
    }
    getConnectedAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            if (!wallet) {
                return [];
            }
            try {
                yield this.reconnectIfNeeded(wallet);
            }
            catch (e) {
                return [];
            }
            const getSelectedAddress = () => wallet.selectedAddress
                ? Promise.resolve([wallet.selectedAddress])
                : Promise.reject();
            return retryableFn(getSelectedAddress, {
                fallbackValue: [],
                maxRetries: 10,
                retryIntervalMs: 750,
                retryStrategy: 'timeout-and-rejection',
            });
        });
    }
}

export { MetaMask };
